import styles from "../Editor.module.css";
import InputControl from "../../InputControl/InputControl";

const AchievementBody = (props) => {
    const sections = props.sections;
    const achvPoints = ["Line1", "Line2", "Line3", "Line4"];
  return (
    <div className={styles.detail}>
    <div className={styles.column}>
      <label>List your achievements</label>
      {achvPoints.map((line, index)=>(
        <InputControl
          placeholder={line}
          value={props.information[sections.achievement].points ? props.information[sections.achievement].points[index] : ""}
          // value={values.points ? values.points[index] : ""}
          onChange={(event) => 
            // handlePointUpdate(event.target.value, index)
            props.setInformation((prev) => ({ ...prev, 
              [sections.achievement]: {...prev[sections.achievement],
                  points: prev[sections.achievement].points.map((point, pointIndex) =>
                    pointIndex === index? event.target.value : point
                  )
              }
            }))
          }
        />
      ))}
    </div>
  </div>
  )
}

export default AchievementBody